import { DEFAULT_PAGE_SIZE } from '@/components';
import {
  parseAsArrayOf,
  parseAsBoolean,
  parseAsInteger,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';
import { commentPublishType, commentReadStatusEnum } from '../models/comment';
import { commentResolvedStatusType } from '../models/search';

export const useCommentListSearchQueryStates = () => {
  return useQueryStates({
    page: parseAsInteger.withDefault(1),
    pageSize: parseAsInteger.withDefault(DEFAULT_PAGE_SIZE),
    ordering: parseAsString.withDefault('-last_modified_at'),
    createdAtFrom: parseAsString,
    createdAtTo: parseAsString,
    keyword: parseAsString,
    readStatus: parseAsStringLiteral(commentReadStatusEnum.options).withDefault(
      'all',
    ),
    isActionRequired: parseAsBoolean.withDefault(true),
    publishType: parseAsStringLiteral(commentPublishType.options).withDefault(
      'open',
    ),
    resolvedStatus: parseAsStringLiteral(
      commentResolvedStatusType.options,
    ).withDefault('all'),
    labelId: parseAsString,
    tagIds: parseAsArrayOf(parseAsString).withDefault([]),
    authorId: parseAsString,
    assigneeId: parseAsString,
    cascader: parseAsString,
    fiscalYear: parseAsInteger,
  });
};
